import requestApiWatcher from 'redux/sagas/request-api';
import graphExecutorWatcher from 'containers/widgets-stats/saga';
import queryExecutorWatcher from 'containers/rest-query/saga';

export default function* rootSaga() {
    yield [requestApiWatcher(), graphExecutorWatcher(), queryExecutorWatcher()];
}
